// CKEditor 5 "extraPlugins" entry to strip color-related styles on paste.
// Applied only where explicitly added to editor config.
export default function StripColorsOnPaste(editor: any) {
  const clipboardPipeline = editor?.plugins?.get?.('ClipboardPipeline')
  const view = editor?.editing?.view

  if (!clipboardPipeline || !view) return

  const stripFromNode = (writer: any, node: any) => {
    if (!node) return

    if (node.is?.('element')) {
      const el = node
      ;[
        'color',
        'background',
        'background-color',
        'background-image',
        '-webkit-text-fill-color',
      ].forEach((styleName) => {
        try {
          writer.removeStyle(styleName, el)
        } catch (_) {
          // ignore - some nodes may not support style ops
        }
      })

      for (const child of el.getChildren()) {
        stripFromNode(writer, child)
      }
      return
    }

    if (node.is?.('documentFragment')) {
      for (const child of node.getChildren()) {
        stripFromNode(writer, child)
      }
    }
  }

  clipboardPipeline.on(
    'inputTransformation',
    (_evt: any, data: any) => {
      const fragment = data?.content
      if (!fragment) return

      view.change((writer: any) => {
        stripFromNode(writer, fragment)
      })
    },
    { priority: 'highest' }
  )
}

